import * as Contract from '../../SharedApiExternalContract';

export class TableauEvent implements Contract.TableauEvent {
  private _type: Contract.TableauEventType;

  public constructor(type: Contract.TableauEventType) {
    this._type = type;
  }

  public get type(): Contract.TableauEventType {
    return this._type;
  }
}



// WEBPACK FOOTER //
// ../../../../src/ApiShared/Events/TableauEvent.ts


// WEBPACK FOOTER //
// webpack:///src/ApiShared/Events/TableauEvent.ts